import React from 'react';
import { alpha, hexToRgb, svgIconClasses } from '@mui/material';
import CheckboxUncheckedIcon from '../../icons/CheckboxUncheckedIcon';
import CheckboxCheckedIcon from '../../icons/CheckboxCheckedIcon';

// eslint-disable-next-line import/prefer-default-export
export const muiCheckboxComponent = {
  defaultProps: {
    disableRipple: true,
    icon: <CheckboxUncheckedIcon />,
    checkedIcon: <CheckboxCheckedIcon />,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      flexShrink: 0,
      height: theme.spacing('2XL'),
      padding: theme.spacing('NONE'),
      width: theme.spacing('2XL'),
      borderRadius: '4px',

      [`&:focus, &.Mui-focusVisible`]: {
        border: `3px solid ${theme.palette.main.professional_blue}`,
      },

      [`& > .${svgIconClasses.root}`]: {
        width: theme.spacing('1XL'),
        height: theme.spacing('1XL'),
        borderRadius: '2px',
      },

      [`&:hover > .${svgIconClasses.root}`]: {
        backgroundColor: alpha(hexToRgb(theme.palette.main.professional_blue), 0.15),
      },

      [`&.Mui-disabled > .${svgIconClasses.root} path`]: {
        fill: theme.palette.main.product_blue,
      },
    }),
  },
};
